import Vue from 'vue';
import { getCookie } from './cookieHelpers';

type TestedApplication = 'shell' | 'tickets' | 'social' | 'stats' | 'gaming' | 'account';
export type TestedFeature = {
    application: TestedApplication;
    feature: string;
};

export function getTestedFeatures(): TestedFeature[] | null {
    if (!window.location.hostname.includes('stage')) {
        return null;
    }
    const features = ['shell', 'tickets', 'social', 'stats', 'gaming', 'account'].map((application) => {
        const feature = getCookie(`${application}Feature`);
        if (feature) {
            return {
                application,
                feature,
            };
        }
        return null;
    }).filter(Boolean) as TestedFeature[];
    return features.length ? features : null;
}

export const showFeatureTestingDisclaimer = Vue.observable({
    showDisclaimer: !!getTestedFeatures(),
});

export function dissmissFeatureTestingDisclaimer(): void {
    showFeatureTestingDisclaimer.showDisclaimer = false;
}
